export const GET_VEHICLES_INFO = "GET_VEHICLES_INFO";
export const GET_VEHICLES_INFO_SUCCCESS = "GET_VEHICLES_INFO_SUCCCESS";
export const GET_VEHICLES_INFO_ERROR = "GET_VEHICLES_INFO_ERROR";

export const SET_VEHICLE_INFO = "SET_VEHICLE_INFO";
export const SET_VEHICLES_INFO_FILTERS = "SET_VEHICLES_INFO_FILTERS";
